export const WsHubMessage = {
    InboxMessageCreated: 'inbox-message-created',
    InboxChannelStatus: 'inbox-channel-status',
    InboxMessageStatus: 'inbox-message-status',
    InboxConversationStatus: 'inbox-conversation-status',
    Notification: 'notification',
    ChannelStatus: id => `Status_${id}`,
    QrCode: id => `QrCode_${id}`,
    TypingStatus: 'typing-status',
};
